/**
 * PDI Loyalty International API v1.5.20
 * Note: All dates/times returned via API call will be UTC / Accept-Encoding: gzip, deflate<br><br><a href='https://pditechnologies.com/engage-customers/loyalty-marketing-solutions/'>PDI Technologies website</a><br><a href='mailto:azpiral-info@pditechnologies.com?subject=AzpiralAPI'>Send an email to PDI Technologies</a><br><a href='../../Contents/FlowDiagrams/Index.htm'>Flow Diagrams</a><br><a href='../../v1/Helpers/ApiErrors/'>Error Codes</a>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ActivateGiftRequest model module.
 * @module model/ActivateGiftRequest
 * @version v1
 */
class ActivateGiftRequest {
    /**
     * Constructs a new <code>ActivateGiftRequest</code>.
     * @alias module:model/ActivateGiftRequest
     * @param giftCardNum {String} MaxLength:25
     * @param giftCardSecurityCode {String} MaxLength:3
     */
    constructor(giftCardNum, giftCardSecurityCode) { 
        
        ActivateGiftRequest.initialize(this, giftCardNum, giftCardSecurityCode);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, giftCardNum, giftCardSecurityCode) { 
        obj['GiftCardNum'] = giftCardNum;
        obj['GiftCardSecurityCode'] = giftCardSecurityCode;
    }

    /**
     * Constructs a <code>ActivateGiftRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ActivateGiftRequest} obj Optional instance to populate.
     * @return {module:model/ActivateGiftRequest} The populated <code>ActivateGiftRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ActivateGiftRequest();

            if (data.hasOwnProperty('GiftCardNum')) {
                obj['GiftCardNum'] = ApiClient.convertToType(data['GiftCardNum'], 'String');
            }
            if (data.hasOwnProperty('GiftCardSecurityCode')) {
                obj['GiftCardSecurityCode'] = ApiClient.convertToType(data['GiftCardSecurityCode'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ActivateGiftRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ActivateGiftRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of ActivateGiftRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['GiftCardNum'] && !(typeof data['GiftCardNum'] === 'string' || data['GiftCardNum'] instanceof String)) {
            throw new Error("Expected the field `GiftCardNum` to be a primitive type in the JSON string but got " + data['GiftCardNum']);
        }
        // ensure the json data is a string
        if (data['GiftCardSecurityCode'] && !(typeof data['GiftCardSecurityCode'] === 'string' || data['GiftCardSecurityCode'] instanceof String)) {
            throw new Error("Expected the field `GiftCardSecurityCode` to be a primitive type in the JSON string but got " + data['GiftCardSecurityCode']);
        }

        return true;
    }


}

ActivateGiftRequest.RequiredProperties = ["GiftCardNum", "GiftCardSecurityCode"];

/**
 * MaxLength:25
 * @member {String} GiftCardNum
 */
ActivateGiftRequest.prototype['GiftCardNum'] = undefined;

/**
 * MaxLength:3
 * @member {String} GiftCardSecurityCode
 */
ActivateGiftRequest.prototype['GiftCardSecurityCode'] = undefined;






export default ActivateGiftRequest;

